import { Box, Button, CircularProgress, PropTypes } from "@material-ui/core";
import React, { MouseEventHandler } from "react";

export interface FormButtonProps {
    loading?: boolean;
    color?: PropTypes.Color;
    type?: "submit" | "reset" | "button";
    onClick?: MouseEventHandler<any>;
    fullWidth?: boolean;
    disabled?: boolean;
    className?: string;
    size?: "medium" | "large" | "small";
    style?: React.CSSProperties;
    startIcon?: React.ReactNode;
    endIcon?: React.ReactNode;
    component?: any;
    autoFocus?: boolean;
}

const FormButton: React.FC<FormButtonProps> = ({
    children,
    loading,
    color,
    type,
    onClick,
    fullWidth,
    disabled,
    className,
    size,
    style,
    startIcon,
    endIcon,
    component,
    autoFocus,
}) => {
    return (
        <Box position="relative">
            <Button
                color={color}
                disabled={loading || disabled}
                type={type}
                onClick={onClick}
                fullWidth={fullWidth}
                className={className}
                size={size}
                style={style}
                startIcon={startIcon}
                endIcon={endIcon}
                component={component}
                autoFocus={autoFocus}
            >
                {children}
                {loading ? (
                    <Box
                        position="absolute"
                        display="flex"
                        alignContent="center"
                        justifyContent="center"
                    >
                        <CircularProgress size={24} />
                    </Box>
                ) : null}
            </Button>
        </Box>
    );
};

export { FormButton };
